import { loadState } from '../utils/localstorage';

export const States = [
    {
        reducerName: 'initialReducer',
        initialState: {
            status: '',
            data: {},
        },
    },
    {
        reducerName: 'loginReducer',
        initialState: {
            status: '',
            data: {},
        },
    },
    {
        reducerName: 'keyInputReducer',
        initialState: {
            status: '',
            data: [],
        },
    },
    {
        reducerName: 'dashboardReducer',
        initialState: {
            status: '',
            allParticipantData: [],
            singleParticipantData: {},
            participantCreateData: {},
            participantUpdateData: {},
            participantDeleteData: {},
        },
    },
    {
        reducerName: 'userReducer',
        initialState: {
            status: '',
            allUserData: [],
            singleUserData: {},
            userCreateData: {},
            userUpdateData: {},
            userDeleteData: {},
        },
    },
    {
        reducerName: 'tentReducer',
        initialState: {
            status: '',
            error: {},
            allTentData: [],
            singleTentData: {},
            tentCreateData: {},
            tentUpdateData: {},
            tentDeleteData: {},
            participantAssignmentData: {},
            participantDetachmentData: {},
        },
    },
    {
        reducerName: 'sidebarReducer',
        initialState: loadState('tentsidebarState') || { isOpen: true },
    },
];
